import {
  ArtistDigitalMembershipCard,
  GetFavoriteMemberCardDesignQuery,
  Maybe,
} from '@/clients/utoniq-core/schema'
import { Head } from '@/components/layouts'
import { ConsoleBaseLayout } from '@/components/layouts/ConsoleBaseLayout'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import {
  FileUploadInfo,
  MembershipCardEditForm,
  MembershipCardEditFormProps,
} from './MembershipCardEditForm'

export type State = {
  artistId: string
  loading: boolean
  progress: number
  favoriteMember:
    | GetFavoriteMemberCardDesignQuery['artistFavoriteMembers'][0]
    | null
  membershipCard: Maybe<ArtistDigitalMembershipCard>
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSubmit: MembershipCardEditFormProps['onSubmit']
  onDrop: FileUploadInfo['onDrop']
}

export const ConsoleDigitalMembershipCardDesignEditTemplate: Template<
  State,
  Action
> = ({ state: { artistId, membershipCard, progress }, onSubmit, onDrop }) => {
  const { t } = useTranslation('consoleDigitalMembershipCardDesignEdit')
  const { routerNames, routerPages } = useRouter()

  return (
    <ArtistThemeProvider artistId={artistId}>
      <ConsoleBaseLayout
        margin
        header={{
          title: t('title'),
          defaultBackPage: routerPages.ConsoleDigitalMembershipCard,
          back: true,
        }}
      >
        <Head
          title={routerNames.ConsoleDigitalMembershipDefaultCardDesignEdit}
        />
        <MembershipCardEditForm
          artistId={artistId}
          membershipCard={membershipCard}
          fileUploadInfo={{ progress: progress, onDrop }}
          onSubmit={onSubmit}
        />
      </ConsoleBaseLayout>
    </ArtistThemeProvider>
  )
}
